import React from 'react'
import InkCollection from './InkCollection'

const Collections = () => {
  return (
    <div><InkCollection/></div>
  )
}

export default Collections
